import { BASE_ENV } from './base-env';

const isReduxLogger = () => {
  const reduxLogger = localStorage.getItem('reduxLogger');
  return reduxLogger === 'false';
};
declare const window: any;
export const environment = {
  ...BASE_ENV,
  production: true,
  appPort: window.__env.appPort,
  securityHost: window.__env.securityHost,
  serverHost: window.__env.serverHost,
  serverPort: window.__env.serverPort,
  serverSecurityPort: window.__env.serverSecurityPort,
  serverSocketPort: window.__env.serverSocketPort,
  securitySocketPort: window.__env.securitySocketPort,
  clientZoneType: window.__env.clientZoneType,
  lang: window.__env.lang,
  emailLogin: window.__env.emailLogin,
  activeLicense: window.__env.activeLicense,
  reduxLogger: isReduxLogger(),
  gaId: 'G-37V00C8QS5',
  gaHost: '10.48.20.174',
  gaPort: '9590',
  gaApiSecret: 'Z0y3AbAmQOuSADuKJ8Fu4Q',
  googleAnalyticsEnable: window.__env.googleAnalyticsEnable,
  versionComponent: window.__env.versionComponent,
};
